/* taken from PDC, but adapted - have comments after each line that has been adapted
 * purpose of adapting was to move the entire page up when scrolling, by changing the padding on the "page-content" element
 * this element contains the hero and sits relative to the rest of the page
 */
(function($) {
	$.heroBanner = function(element, options) {

		var defaults = {
			sectionOffset : 0,
			contentOffset : -26,
			moveNextSection : true,
			hasContextual   : false,
			pullUpClassNames : ['headingWrapper', 'moduleComponent', 'moduleComponentOverflow'],
			pageContentPaddingTop : $("#global_sonyBar").height(),
			animateSpeed : 200 //james
		};

		//DOM elements for letterbox
		var $element = $(element), $parentSection = $element.parents("section"), $nextSection = $parentSection.next("section"), leftShapes = $(".left-shapes"), rightShapes = $(".right-shapes"), pageContent = $("#page-content"), scrollTopTrigger = $(".scroll-up-action"), header = $("#main-header"), faders = $("body").find(".fadeItem"), heroBg = $(".banner-image");
		var bIsTouch = eM.isTouchDevice(), isExcludedBrowser = $(".lt-ie8").length > 0;

		var plugin = this;
		plugin.settings = {};

		plugin.init = function() {

			if ( typeof ScrollControl === 'undefined') {
				ScrollControl = new ScrollrControllr();
			}

			plugin.settings = $.extend({}, defaults, options);

			plugin.settings.hasContextual = $( '#main-nav' ).find( '.pdc6-contextual-nav' ).size() > 0;

			if( plugin.settings.hasContextual )
			{
				plugin.settings.pageContentPaddingTop += 64;
			}

			if (plugin.settings.moveNextSection) {

				$nextSection.css({
					position : "relative",
					top : plugin.settings.sectionOffset + "px"
				});

				var $children = $nextSection.children('div'), bSuccess = false;

				$children.each(function() {

					var $this = $(this);

					$.each(plugin.settings.pullUpClassNames, function(nIndex, sModuleClassName) {

						if ($this.hasClass(sModuleClassName)) {

							$this.css({
								position : "relative",
								marginTop : plugin.settings.contentOffset + "px"
							});

							bSuccess = true;
							return false;
						}

					});

					if (bSuccess)
						return false;

				});

				$nextSection.find("> :first-child");
			}
			//console.log("BT: " + eM.isTouchDevice());
			if (!bIsTouch && !isExcludedBrowser) {
				//$(window).bind('scroll', bannerParallax);

				ScrollControl.registerScrollListener(function() {
					bannerParallax(arguments);
				}, $element);
			} else {
				document.addEventListener("touchmove", moveHeader, false);
				document.addEventListener("scroll", moveHeader, false);
			}

			var goToTop = function( e )
			{
				e && e.preventDefault();

				$( "html, body").animate( {
					scrollTop : '0'
				}, 600, "easeOutQuad", function() {
					//nowt
				} )
			};

			if( plugin.settings.hasContextual )
			{
				$( '#contextual-nav-to-top' ).click( goToTop );
			}

			scrollTopTrigger.click( goToTop );

		};

		//Initialise the plug-in
		plugin.init();
		var pcTop = plugin.settings.pageContentPaddingTop;
		var headerOffset = plugin.settings.headerOffset;
		var aSpeed = plugin.settings.animateSpeed;
		function getScrollTop(){
			return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
		}
		function moveHeader(nDocViewTop) {
			//console.log(typeof (nDocViewTop));
			if ((typeof (nDocViewTop) == "undefined") || (typeof (nDocViewTop) == "object")) {
				var nDocViewTop = getScrollTop();

			}
			//console.log("mH", "NDVT: " + nDocViewTop, "PCTOP: " + pcTop);
			if (nDocViewTop <= pcTop) {

				heroBg.css({
					'position' : 'absolute',
					"top" : '0'
				});
				header.css({
					'position' : 'absolute',
					"top" : '0'
				});

			} else {

				header.css({
					'position' : 'fixed',
					"top" : plugin.settings.pageContentPaddingTop * -1
				});
				heroBg.css({
					'position' : 'fixed',
					"top" : plugin.settings.hasContextual ? 0 : 64
				});

			}
		}

		function bannerParallax(arguments) {
			//console.log("bp called");
			var nDocViewTop = getScrollTop();
			// var nDocViewTop = arguments[0];
			var nDocHeight = $(window).height();

			var nOpacity = (1 - (nDocViewTop / nDocHeight) * 3);
			var nMovement = -3 - ((nDocViewTop / nDocHeight) * 30);

			leftShapes.css("left", nMovement + "%");
			rightShapes.css("right", nMovement + "%");

			faders.css({
				opacity : nOpacity
			});
			moveHeader(nDocViewTop);

		};

		//we need to look for anchors

		if (location.hash != "") {
			//console.log("found hash");
			//we may have an anchor - let's find the element
			$("a").each(function() {
				var t = $(this);
				//console.log("checking a: #"+t.attr("name"));
				if ("#" + t.attr("name") == location.hash) {
					//console.log("doing offset");
					var offset = t.offset();
					//console.log("offset: " + offset.top);
					moveHeader(offset.top);
				}

			});
		}
		//adjust for anchored clicks
		$("a").click(function(){
			//see if the link is for the current page
			var t = $(this);
			var href = t.attr("href");
			if((href.search(location.href)) && (href.search("#"))){
				//need to get the anchor target
				var anchor_split = href.split("#");
				var offset = $("a[name="+anchor_split[1]+"]").offset();
				if(typeof(offset) != "undefined"){
					moveHeader(offset.top);
				}


			}
		});

	};

	$.fn.heroBanner = function(options) {

		return this.each(function() {
			if (undefined == $(this).data('heroBanner')) {
				var plugin = new $.heroBanner(this, options);
				$(this).data('heroBanner', plugin);
			}
		});

	};
})(jQuery);